angular.module('units')
    .directive('unitSelect', function ($filter, $timeout, Unit) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                lang: '=?',
                units: '=?'
            },
            template: `
                <div style="min-width: 80px;">
                    <select class="form-control unit-selector" ng-model="selected" ng-options="langFilter(option.symbol) for option in units track by option.id" ng-change="onSelectionChanged()">
                        <option value=""></option>
                    </select>
                </div>
            `,
            link: function (scope, $element, $attrs, ngModelCtrl) {

                if (!scope.units) {
                    scope.units = []
                    Unit.list().$promise.then(items => {
                        scope.units = items
                        if (!ngModelCtrl.$viewValue) {
                            scope.selected = Unit.getDefault(items)
                            scope.onSelectionChanged()
                        }
                    })
                }

                scope.langFilter = key => {
                    if (scope.lang)
                        return $filter('localizedWithLang')(key, scope.lang)
                    else
                        return $filter('localized')(key)
                }

                ngModelCtrl.$render = () => scope.selected = ngModelCtrl.$viewValue
                ngModelCtrl.$formatters.push(modelValue => modelValue)
                ngModelCtrl.$parsers.push(viewValue => viewValue)

                scope.onSelectionChanged = () => {
                    ngModelCtrl.$setViewValue(scope.selected)
                    ngModelCtrl.$validate()
                    ngModelCtrl.$render()
                }
            }
        }
    })
